import React from 'react';
import PropTypes from 'prop-types';
import Group from './group';
export default function Modal(props) {
  return /*#__PURE__*/React.createElement(Group, {
    type: "modal",
    title: props.title,
    body: props.children,
    primaryBtn: props.primaryBtn,
    secondaryBtn: props.secondaryBtn
  });
}
const buttonShape = {
  label: PropTypes.string,
  onPress: PropTypes.func
};
Modal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.string,
  primaryBtn: PropTypes.shape(buttonShape),
  secondaryBtn: PropTypes.shape(buttonShape)
};
Modal.defaultProps = {
  title: '',
  children: '',
  primaryBtn: {
    label: '',
    onPress: () => {}
  },
  secondaryBtn: {
    label: '',
    onPress: () => {}
  }
};
//# sourceMappingURL=modal.js.map